export default __webpack_public_path__ + "static/avatar-kortical-team2-17c9550ecdac9a2dda14b308bbf00d57.webp";